import { createSlice } from '@reduxjs/toolkit';

const redirectUrlSlice = createSlice({
  name: 'redirectUrl',
  initialState: {
    url: null
  },
  reducers: {
    setRedirectUrl: (state, action) => {
      state.url = action.payload;
    }
  }
});

export const { setRedirectUrl } = redirectUrlSlice.actions;
export default redirectUrlSlice.reducer;
